import React, {useContext, useEffect, useState} from 'react';
import {ThemeProvider} from '@material-ui/core/styles';
import {light} from './theme';
import {BrowserRouter as Router,  } from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {renderRoutes} from 'react-router-config';
import {GlobalContext} from "./contexts/context";
import {getLocalStorage, setLocalStorage, updateState} from "./services/local_storage";
import routes from './routes';
import {ProgressSpinner} from "./components";
import {initState} from "./contexts/initState";
import './mixins/validate';
require('dotenv').config()

const history = createBrowserHistory();

const App = () => {
    const context = useContext(GlobalContext);
    const [initializing, setInitializing] = useState(true);

    const appVersion = async () => {
        const current = await getLocalStorage();
        if (current && (!current.hasOwnProperty("version") || (current.hasOwnProperty("version") && current.version !== initState.version)))
            await updateState();
    }

    const currentSession = async () => {
        const user = await context.loadUser();
        const uV = new Date(user.verifiedTime); // user verified time
        const userVerifiedLiveUntil = new Date(uV.setHours(uV.getHours() + Number(user.sessionTTL)));
        if(!user?.verified || userVerifiedLiveUntil < new Date()){
            const login = `${window.location.origin}/login`
            context.saveLocalState("user", {
                ...initState.user
            })
            if(window.location.href !== login)
                window.location.href = login;
        } else {
            const dashboard = `${window.location.origin}/dashboard`
            if(window.location.href !== dashboard)
                window.location.href = dashboard;
        }

        setInitializing(false);
    }

    useEffect(() => {
        appVersion();
        currentSession();
    }, []);

  return (
      <ThemeProvider theme={light}>
          <Router history={history}>
              {
                  !initializing ? renderRoutes(routes) :
                      <ProgressSpinner
                          message={"Initializing App..."}
                          height={"100vh"}
                          size={150}
                      />
              }
          </Router>
      </ThemeProvider>
  );
};

export default App;
